import { Tooltip } from "antd";

const ProductCard = ({ product }) => {

    // Slug oluşturma fonksiyonu
    const createSlug = (text: string) => {
        if (!text) return '';
        return text
            .toString()
            .toLowerCase()
            .trim()
            .replace(/ı/g, 'i')
            .replace(/ğ/g, 'g')
            .replace(/ü/g, 'u')
            .replace(/ş/g, 's')
            .replace(/ö/g, 'o')
            .replace(/ç/g, 'c')
            .replace(/[^\w\s-]/g, '')
            .replace(/\s+/g, '-')
            .replace(/--+/g, '-');
    };

    // Detay sayfasına yönlendirme
    const handleProductClick = () => {
        const slug = `${createSlug(product.name)}-${product._id}`;
        window.location.href = `/lastik/${slug}`;
    };
    const getMainImage = () => {
        let imagePath = '';
        if (product.downloaded_images && product.downloaded_images.length > 1) {
            // İlk resim genelde logo, ikinci resim ürün resmi
            imagePath = `/uploads/${product.downloaded_images[1]}`;
        } else if (product.downloaded_images && product.downloaded_images.length > 0) {
            imagePath = `/uploads/${product.downloaded_images[0]}`;
        } else {
            return '/images/no-image.webp'; // Varsayılan resim
        }
        // PNG/JPG uzantılarını WebP'ye çevir
        return imagePath.replace(/\.(png|jpg|jpeg|gif)$/i, '.webp');
    };

    const getBrandLogo = () => {
        if (product.downloaded_images && product.downloaded_images.length > 0) {
            // İlk resim genelde marka logosu
            const logoPath = `/uploads/${product.downloaded_images[0]}`;
            // PNG/JPG uzantılarını WebP'ye çevir
            return logoPath.replace(/\.(png|jpg|jpeg|gif)$/i, '.webp');
        }
        return null;
    };



    return (
        <div
            key={product._id}
            onClick={handleProductClick}
            className='w-full sm:w-[49%] md:w-[49%] lg:w-[32%] xl:w-[23%] 2xl:w-[18%] min-w-52 border
         rounded-md bg-white hover:shadow-lg transition-shadow duration-300 pb-4 flex flex-col gap-4 cursor-pointer'
            itemScope
            itemType="https://schema.org/Product"
        >

            {/* Ürün Resmi */}
            <div className='w-full flex justify-center relative'>
                <img
                    src={getMainImage()}
                    alt={`${product.brand_name} ${product.tire_size} ${product.name} - Lastik Fiyatları`}
                    title={`${product.brand_name} ${product.tire_size} Lastik`}
                    className='w-full h-40 object-cover rounded-t-lg'
                    itemProp="image"
                />
                {/* Marka Logosu */}
                {getBrandLogo() && (
                    <div className='absolute top-2 left-2 bg-white rounded px-1 py-0.5 shadow-sm'>
                        <img
                            src={getBrandLogo() || ''}
                            alt={`${product.brand_name} Logo`}
                            title={product.brand_name}
                            className='h-6 w-auto object-contain'
                        />
                    </div>
                )}
                {/* Sezon Etiketi */}
                <div className='absolute top-2 right-2 bg-blue-500 text-white text-xs px-2 py-1 rounded'>
                    {product.properties?.season || product.tire_type}
                </div>
            </div>

            {/* Hidden Schema.org meta data */}
            <meta itemProp="name" content={product.name} />
            <meta itemProp="brand" content={product.brand_name} />
            <meta itemProp="sku" content={product.sku || product._id} />
            <meta itemProp="description" content={`${product.brand_name} ${product.tire_size} lastik modeli. ${product.properties?.season || product.tire_type} özellikli.`} />

            <div className='w-full flex flex-col items-center gap-4 overflow-hidden px-3'>
                {/* Marka ve Ürün Adı */}
                <div className='flex flex-col items-center gap-2 text-center'>
                    <div className='text-blue-600 font-semibold text-sm'>{product.brand_name}</div>
                    <div className='font-bold text-lg text-gray-800 overflow-hidden text-ellipsis w-[98%] line-clamp-2'>
                        <Tooltip title={product.name}>
                            {product.name}
                        </Tooltip>
                    </div>
                    {/* Kategori */}
                    {product.category && (
                        <div className='text-xs text-gray-700 bg-gray-50 px-2 py-1 rounded border border-gray-200'>
                            📂 {typeof product.category === 'object' ? product.category.name : product.category}
                        </div>
                    )}
                </div>

                {/* Lastik Ölçüleri */}
                <div className='flex flex-col items-center gap-2'>
                    <div className='text-gray-700 text-sm font-mono bg-gray-100 px-3 py-1 rounded border border-gray-200'>
                        {product.tire_size}
                    </div>
                    <div className='text-xs text-gray-600'>
                        {product.properties?.width}/{product.properties?.aspect_ratio}/R{product.properties?.rim_diameter}
                    </div>
                </div>

                {/* Özellikler */}
                <div className='flex flex-wrap justify-center gap-1'>
                    {product.properties?.load_index && (
                        <span className='text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded'>
                            Yük: {product.properties.load_index}
                        </span>
                    )}
                    {product.properties?.speed_index && (
                        <span className='text-xs bg-blue-100 text-blue-700 px-2 py-0.5 rounded'>
                            Hız: {product.properties.speed_index}
                        </span>
                    )}
                    {product.production_year && (
                        <span className='text-xs bg-purple-100 text-purple-700 px-2 py-0.5 rounded'>
                            {product.production_year}
                        </span>
                    )}
                </div>

                {/* Stok Durumu */}
                {product.stock_amount !== undefined && (
                    <div className={`text-xs px-2 py-1 rounded ${product.stock_amount > 0
                        ? 'bg-green-100 text-green-700'
                        : 'bg-red-100 text-red-700'
                        }`}>
                        Stok Sorunuz
                        {/* {product.stock_amount > 0
                            ? `Stokta ${product.stock_amount} adet`
                            : 'Stokta Yok'
                        } */}
                    </div>
                )}

                {/* Fiyat */}
                <div className='flex flex-col items-center gap-1' itemProp="offers" itemScope itemType="https://schema.org/Offer">
                    <meta itemProp="price" content={String(product.discounted_price || product.price)} />
                    <meta itemProp="priceCurrency" content="TRY" />
                    <meta itemProp="availability" content={product.stock_amount > 0 ? "https://schema.org/InStock" : "https://schema.org/OutOfStock"} />
                    <link itemProp="url" href={`https://sakaryalastik.com/lastik/${product._id}`} />

                    {(() => {
                        const currentPrice = product.discounted_price || product.price;

                        return (
                            <>
                                <div className='flex items-center justify-center gap-2'>
                                    {/* Taksitli Fiyat (Sol) */}
                                    <div className='flex flex-col items-center'>
                                        <span className='text-gray-500 text-xs'>Taksitli</span>
                                        <span className='text-gray-600 text-sm font-semibold'>
                                            ₺{Math.round(currentPrice * 1.1)?.toLocaleString('tr-TR')}
                                        </span>
                                    </div>

                                    <span className='text-gray-400 text-lg mx-1'>|</span>

                                    {/* Ana Fiyat (Sağ) */}
                                    <div className='flex flex-col items-center'>
                                        <span className='text-gray-500 text-xs'>Peşin</span>
                                        {product.discounted_price ? (
                                            <span className='text-green-600 font-bold text-lg'>₺{product.discounted_price?.toLocaleString('tr-TR')}</span>
                                        ) : (
                                            <span className='text-gray-800 font-bold text-lg'>₺{product.price?.toLocaleString('tr-TR')}</span>
                                        )}
                                    </div>
                                </div>
                            </>
                        );
                    })()}
                </div>

                {/* EU Etiket Bilgileri (varsa) */}
                {(product.properties?.fuel_efficiency || product.properties?.wet_grip || product.properties?.noise_decibel) && (
                    <div className='flex justify-center gap-2 text-xs'>
                        {product.properties?.fuel_efficiency && (
                            <div className='text-center'>
                                <div className='text-gray-700'>Yakıt</div>
                                <div className='font-semibold text-green-700'>{product.properties.fuel_efficiency}</div>
                            </div>
                        )}
                        {product.properties?.wet_grip && (
                            <div className='text-center'>
                                <div className='text-gray-700'>Islak</div>
                                <div className='font-semibold text-blue-700'>{product.properties.wet_grip}</div>
                            </div>
                        )}
                        {product.properties?.noise_decibel && (
                            <div className='text-center'>
                                <div className='text-gray-700'>Gürültü</div>
                                <div className='font-semibold text-orange-700'>{product.properties.noise_decibel}dB</div>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    )
}

export default ProductCard;